import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import TypeIcon from 'components/typeIcon/TypeIcon'

import treeStringify from 'utils/treeStringify'

import styles from './treeRowEnum.scss'

interface IProps {
  path: string
  isSelected: boolean
  fieldName: string
  value: string | number | boolean
  style: React.CSSProperties
  onClick: (path: string) => void
}

class TreeRowEnum extends React.PureComponent<IProps> {
  handleClick = (e: React.FormEvent) => {
    const { path, onClick } = this.props

    e && e.stopPropagation()
    onClick(path)
  }

  render() {
    const { path, isSelected, fieldName, value, style } = this.props

    const depth = path.split('::').length - 1

    return (
      <div
        data-cy="tree__enum"
        style={style}
        className={cn(styles.container, {
          [styles.active]: isSelected,
        })}
        tabIndex={1}
        onClick={this.handleClick}
      >
        <div className={styles.depthGutter} style={{ width: depth * 16 }}></div>

        <div className={styles.meta}>
          <TypeIcon className={styles.icon} enumerable required />
          {fieldName && <div className={styles.fieldName}>{fieldName}:</div>}
        </div>

        <div className={styles.fieldValue}>{treeStringify(value)}</div>
      </div>
    )
  }
}

export default observer(TreeRowEnum)
